var map = {
	"./ach.json": 2938,
	"./ar.json": 1065,
	"./de.json": 2629,
	"./en.json": 2105,
	"./es.json": 7962,
	"./fr.json": 6386,
	"./id.json": 3035,
	"./it.json": 139,
	"./ja.json": 3007,
	"./pl.json": 5006,
	"./pt.json": 2758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6030;